import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Link from 'next/link'
import React from 'react'
import moment from 'moment-timezone'
import { MdLocationOn } from 'react-icons/md'
import { FaRegCalendarAlt } from 'react-icons/fa'
import CommentCell from './CommentCell'
import VideoCellList from './VideoCellList'
import LiveViewButton from './LiveViewButton'
import Router from 'next/router'
import LonelyCard from './LonelyCard'
import { Default, Mobile } from './ViewTypes'
import UtilsManager from '../managers/UtilsManager'
import Badge from 'react-bootstrap/Badge'

const GREY = "#9E9E9E"
const UNIVERSE = 'rgba(28,35,43,.15)'


export default class EventCell extends React.Component { 

	constructor(props) { 
		super(props)
		this.utilsManager = new UtilsManager()
	}

	getTimeZone() { 
		return this.utilsManager.getTimeZone(this.props.event, true)
	}

	onClicked() { 
		if (this.props.onClick !== undefined && this.props.onClick !== null) { 
			this.props.onClick(this.props.event.id)
		} else  {
			Router.push('/event/' + this.props.event.id)
		}
	}

	_getDateAndTimeFormat() { 
		const val = moment.tz(this.props.event.start_date, this.getTimeZone()).format('ddd MMM Do, h:mm a')
		return val.toString()
	}

	getCommentCell() { 
		if (this.props.event.newest_comment != null) { 
		return (<CommentCell style={{marginTop: 20}}
			comment={this.props.event.newest_comment}
			truncate
			/>)
		} else { 
			return null
		}
	}

	getCommentCount() { 
		if (this.props.event.comments == null) { 
			return null
		}

		const commentCount = this.props.event.comments.length
		if (commentCount == 0) { 
			return "View info and chat"
		}

		if (commentCount == 1) { 
			return "View 1 comment"
		}

		return "View all " + this.props.event.comments.length + " comments"
	}

	getCardStyle() { 
		const styles = {boxShadow: `0px 0px 10px ${UNIVERSE}`,
						width: this.props.width,
						cursor: "pointer"
					}
		if (this.props.horizontal) {
			styles.flex = '0 0 auto'
			styles.marginRight = "20px"
		}
		return styles
	}

	getCost() { 
		if (this.props.event.cost === 0) { 
			return "Free"
		} else { 
			return "from $" + this.props.event.cost
		}
	}

	getBody() { 
		return (
			<Card.Body>
			        <div onClick={()=> this.onClicked()}>
				      <Card.Title><bold>{this.props.event.title}</bold></Card.Title>
				      <div style={{display:'flex', marginBottom:8}} onClick={()=> this.onClicked()}>
				      	  <MdLocationOn style={{marginTop: 3, marginRight:10}}/>
					      <Card.Text>
					      {this.props.event.place}
					      </Card.Text>
					   </div>
					 <div style={{display:'flex'}}>
					 	<FaRegCalendarAlt style={{marginRight: 10, marginTop:3}} />
					   <Card.Text>
					   {this._getDateAndTimeFormat()}
					   </Card.Text>
					 </div>

					 <div style={{marginTop: 20, display: 'flex'}}>
					 	<Card.Title>{this.getCost()}</Card.Title>
					 	<Default>
					 		<LiveViewButton event={this.props.event} divStyle={{marginLeft: '30%'}} />
					 	</Default>
					 	<Mobile>
					 		<LiveViewButton event={this.props.event} divStyle={{marginLeft: '50%'}} textStyle={{fontSize: 10}} />
					 	</Mobile>
					 </div>
					 {this.props.event.tags && this.props.event.tags.map((item, index) => <Badge style={{marginRight: '5px'}} variant="info">{item.label}</Badge>)}
				 </div>
				 
				  {this.props.event.videos !== undefined && <VideoCellList videos={this.props.event.videos} 
				  onVideoClick={(videoUrl)=>this.props.onVideoClick(videoUrl, null)} /> }
			    </Card.Body>
			)
	}


	render() { 
		if (this.props.type === "v2") { 
			return <div id="event_div" style={this.props.style}>
				<div style={{backgroundColor: 'black', height: '100%', width: '100%',
						backgroundImage: `url(${this.getImage()})`, backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}>

				</div>
				<div style={{marginTop: '20px'}}>
					<p style={{textAlign: 'center'}}><strong>{this.props.event.title}</strong></p>
					<p style={{textAlign: 'center'}}>{this._getDateAndTimeFormat()}</p>
					<p style={{textAlign: 'center'}}><small>{this.props.event.place}</small></p>
				</div>
			</div>
		}
		if (this.props.type === "lonely") { 
			return <LonelyCard className="event-image" 
								style={{...this.getCardStyle(), ...this.props.style}} 
								image={this.props.event.image_url}
								onClick={() => this.onClicked()}>
				{this.getBody()}
			</LonelyCard>
		}
		return (
			<Card style={{...this.getCardStyle(), ...this.props.style}} className="event">
			    <div className="event-image" onClick={()=> this.onClicked()} style={this.getImageStyle()}>
			    </div>
			    {this.getBody()}
			 </Card>
  		)
	}

	getImage() { 
		if (this.props.event.image_url == null || this.props.event.image_url == undefined) { 
			return "https://s3.us-east-2.amazonaws.com/gameplan-image-urls/icon.jpg"
		} else { 
			return this.props.event.image_url
		}
	}

	getImageStyle()  { 
		var height = "230px"
		if (this.props.mobile == true) { 
			height = "160px"
		}
		const divStyle = { 
			backgroundImage: `url(${this.getImage()})`, 
			width:'100%', 
			height:height,
			backgroundSize: 'cover',
			backgroundPosition: 'center', 
			diplay: 'flex'
		}

		return divStyle
	}

}
